import styled, { css,keyframes } from 'styled-components/macro'

import { colors } from 'styled/theme.styled'

export const Root = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;

  transform: scale(${({ selected }) => (selected ? 1 : 0.75)});
  transition: all 0.2s;

  > .Year {
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 4px;
    color: ${colors.darkBlue};
  }

  > .Name {
    ${({ isPortrait }) =>
      isPortrait
        ? css`
            font-size: 14vw;
          `
        : css`
            font-size: 96px;
          `};
    font-weight: 900;
    text-align: center;
    white-space: nowrap;
    color: ${colors.darkBlue};
    opacity: 0.25;

    /* @supports (-webkit-text-stroke: 1px ${colors.darkBlue}) {
      color: transparent;
      -webkit-text-stroke: 1px ${colors.darkBlue};
    } */

    > * {
      display: inline-block;
    }
  }
`

export const FeatureButton = styled.div`
  position: absolute;
  bottom: 48px;
  right: calc(50% - 72px);
  width: 48px;
  height: 48px;
  border-radius: 999px;
  background-color: ${colors.darkBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(${({ selected }) => (selected ? 1 : 0)});
  transition: transform 0.3s;

  > svg {
    display: block;
    fill: ${colors.faintBlue};
    width: 24px;
  }

  &:hover {
    cursor: pointer;
  }

  /* Utilisation d'une media query pour appliquer un transform différent selon la taille de la fenêtre */
  @media (max-width: 1024px) {
    transform: translateX(0%);
    bottom: -20px;
    margin-left: calc(50% - 80px);
  }

  @media (min-width: 1025px) {
    margin-left: -40%
  }
`


const breatheAnimation = keyframes`
 0% { background-color: ${colors.darkBlue}; }
 40% { background-color: ${colors.darkBlue}; }
 70% { background-color: #0aaadf; }
 100% { background-color: ${colors.darkBlue}; }
`


export const FeatureButtonBlink = styled(FeatureButton)`

  animation: ${breatheAnimation} 2s ease-in-out infinite;
  padding-left: 6px;
  div.rootbt{
    position:absolute;
    background-color: ${colors.darkBlue};
    padding:4px 10px 4px 10px;
    top:-30px;
    color:white;
    border-radius: 0 0 5px 5px;
   
    white-space: nowrap;
    width:120px;
    font-size:80%;
    text-align: center;
    opacity:0.5;
   
  }
  `


  